export const APP_KEY = '1u6r7ppoy2kgh7f';